import type { Currency } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { CashoutMethodType } from '../../types/Cashier';
import type { RollbackOverCreditOption } from '../../types/Cashier';
import { CardType } from '../../types/cardType';
import PaymentMethodLogo from '../PaymentMethodLogo/PaymentMethodLogo';
import CurrencyConversionDescription from '../Withdraw/components/CurrencyConversionDescription/CurrencyConversionDescription';
import WithdrawCreditTime from '../Withdraw/components/WithdrawCreditTime/WithdrawCreditTime';

import { info, listItem, message, options, payment } from './TransactionsPanel.scss';

interface Props {
  balanceCurrency: Currency;
  errorTransaction?: boolean;
  rollbackOverCreditOptions?: RollbackOverCreditOption[];
  accountNumber?: number;
  isVerification?: boolean;
}

const TransactionsPanel: React.FC<Props> = ({
  balanceCurrency,
  errorTransaction,
  rollbackOverCreditOptions,
  accountNumber,
  isVerification = false
}) => (
  <ul className={options}>
    {rollbackOverCreditOptions?.map(
      (
        {
          cardType,
          amt: amount,
          ref: description,
          currency,
          paySystemName,
          processorAmount: convertedAmount,
          rate,
          overCreditCurrency
        },
        index
      ) => (
        <li key={index} className={classNames(listItem)}>
          <PaymentMethodLogo cardType={cardType} i18nSystemName={paySystemName} variant="result" />

          <div className={info}>
            <div className={payment}>
              {paySystemName} {cardType === CardType.PsPayAstropay ? accountNumber : description}
            </div>
            {!errorTransaction && !isVerification && (
              <div className={message}>
                <CurrencyConversionDescription
                  targetCurrency={overCreditCurrency || currency}
                  sourceCurrency={balanceCurrency}
                  convertedAmount={convertedAmount}
                  currentAmount={amount}
                  rate={rate}
                />

                <WithdrawCreditTime
                  cardType={cardType}
                  methodType={
                    overCreditCurrency ? CashoutMethodType.OverCredit : CashoutMethodType.Rollback
                  }
                  showOverCreditTime
                />
              </div>
            )}
          </div>
          {!isVerification && (
            <span className={payment}>
              <CurrencyAmount value={amount} currency={balanceCurrency} currencyDisplay="code" />
            </span>
          )}
        </li>
      )
    )}
  </ul>
);

export default TransactionsPanel;
